if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      //this.form.querySelector('[name=id]').disabled = false;
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) {
        if(this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            const isIconicKitLimitError = response.description?.includes('The Iconic Trial Kit') && response.description?.includes('Quantity error');
            const errorMessage = isIconicKitLimitError
              ? 'Looks like you’ve got your Iconic Kit already! 😉 One per customer, please.'
              : response.description;

            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: errorMessage, message: response.message});
            this.handleErrorMessage(errorMessage);

            if (isIconicKitLimitError) {
              this.error = false;
              return;
            }

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: response});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { 
                // this.cart.renderContents(response) 
                window.openFloCartWhenReady();
              });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            // this.cart.renderContents(response);
            window.openFloCartWhenReady();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) {
        this.errorMessageWrapper = document.createElement('div');
        this.errorMessageWrapper.className = 'product-form__error-message-wrapper';
        this.errorMessageWrapper.setAttribute('role', 'alert');

        this.errorMessage = document.createElement('span');
        this.errorMessage.className = 'product-form__error-message';
        this.errorMessageWrapper.append(this.errorMessage);

        const cardInformation = this.closest('product-info')?.querySelector('.card__information');
        const cardPrice = cardInformation?.querySelector('.card-information');

        if (cardPrice) {
          cardPrice.insertAdjacentElement('afterend', this.errorMessageWrapper);
        } else if (cardInformation) {
          cardInformation.append(this.errorMessageWrapper);
        } else {
          this.submitButton.insertAdjacentElement('afterend', this.errorMessageWrapper);
        }
      }

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      const isIconicKitLimitMessage = errorMessage === 'Looks like you’ve got your Iconic Kit already! 😉 One per customer, please.';
      if (isIconicKitLimitMessage) {
        Object.assign(this.errorMessageWrapper.style, {
          margin: '1rem 0',
          padding: '0.8rem 1rem',
          width: '100%',
          boxSizing: 'border-box',
          border: '1px solid currentColor',
          borderRadius: '0.4rem',
          background: '#fff1f2',
          color: '#be123c',
          fontSize: '1.5rem',
          lineHeight: '1.4',
          fontWeight: '700'
        });
      }

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  });
}